import { render, staticRenderFns } from "./RemoveButton.vue?vue&type=template&id=4614fcfd&scoped=true&functional=true&"
import script from "./RemoveButton.vue?vue&type=script&lang=js&"
export * from "./RemoveButton.vue?vue&type=script&lang=js&"
import style0 from "./RemoveButton.vue?vue&type=style&index=0&id=4614fcfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4614fcfd",
  null
  
)

export default component.exports